import * as Yup from 'yup';
import { AssetProfileDataModel } from '../../types/assetProfile.interface';

export const assetSchema = Yup.object<AssetProfileDataModel>().shape({
  nbaths: Yup.number().notRequired().integer('Bathrooms must be an integer'),
  rooms: Yup.number().notRequired().integer('Rooms must be an integer'),
  listingType: Yup.number()
    .required('Listing type is required')
    .oneOf(
      [1, 2, 5, 6, 7, 8, 11, 12],
      'Listing type must be one of [1, 2, 5, 6, 7, 8, 11, 12]'
    ),
  operation: Yup.number()
    .required('Operation is required')
    .oneOf([0, 1], 'Operation must be one of [0, 1]'),
  lat: Yup.number().required('Latitude is required'),
  lon: Yup.number().required('Longitude is required'),
  address: Yup.string().required('Address is required'),
  area: Yup.number()
    .required('Area is required')
    .notOneOf([0], 'Area must be greater than 0'),
  parcelArea: Yup.number().notRequired().nullable(),
  floor: Yup.number().notRequired().integer('Floor must be an integer'),
  propertyType: Yup.number().notRequired(),
  yearBuilt: Yup.number()
    .notRequired()
    .integer('Year built must be an integer'),
  reportType: Yup.number().required('Report type is required'),
  buildStatus: Yup.number()
    .nullable()
    .integer('Build status must be an integer'),
  estimatedPrice: Yup.number().nullable().notRequired(),
  estimatedPriceSqm: Yup.number().nullable().notRequired(),
  estimatedMin: Yup.number().nullable().notRequired(),
  estimatedMax: Yup.number().nullable().notRequired(),
});
